export enum FeatureType {
  Regular = 0,
  ClickThrough = 1
}
